<template>
  <v-container grid-list-xl class="pa-5">
    <v-row dense class="mb-2">
      <v-col cols="12" md="10" sm="12">
        <v-alert v-if="is_premium" dense text class="body-2 mb-5" type="info">
          Berikut ini merupakan data kategori Jam Kerja, yang nantinya dapat diterapkan sebagai jadwal pengguna.
          Pastikan label jam kerja satu dengan label jam kerja yang lain <b>berbeda</b>, guna membedakan jam kerja satu
          dengan jam kerja yang lainnya
        </v-alert>
      </v-col>
      <v-col cols="12" md="2" sm="12" class="text-center">
        <v-card class="pa-0 elevation-custom" id="kodeorganisasi">
          <v-card-text>
            <div class="body-2 font-weight-bold primary--text mx-auto"> Zona Waktu </div>
            <div>
              <span class="teal--text text--accent-5">
                {{ (current_konfigurasi && current_konfigurasi.timezone) || 'Asia/Jakarta' }}
              </span>
              <span class="black--text"
                >({{ itemZonaWaktu[(current_konfigurasi && current_konfigurasi.timezone) || 'Asia/Jakarta'] }})</span
              >
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <m-card-list
      two-line
      title="Jam Kerja"
      label-cari="Cari Jam Kerja"
      :add="isCan(`jadwal.${keyAkses}store`)"
      :edit="isCan(`jadwal.${keyAkses}update`)"
      search
      :items="items"
      :headers="headers"
      refresh
      @refresh="load"
      :page="page"
      footer
      @search="
        (search) => {
          textSearch = search
          load()
        }
      "
      @change:page="
        (pg) => {
          cp = pg
          load()
        }
      "
      @add="add"
    >
      <template v-slot:filter>
        <div class="text-right">
          <m-button
            v-if="isCan('jadwal.set-jadwal-group')"
            dark
            class="ma-2 elevation-7"
            text="Set Jadwal Grup"
            icon="mdi-account-group"
            :large="false"
            color="orange"
            action="setJadwalGrup"
            @setJadwalGrup="setJadwalGrup"
          ></m-button>
          <m-button
            v-if="isCan('jadwal.set-jadwal-user')"
            dark
            class="ma-2 elevation-7"
            text="Set Jadwal Individu"
            icon="mdi-account"
            :large="false"
            color="primary"
            action="setJadwal"
            @setJadwal="setJadwal"
          ></m-button>
        </div>
      </template>
      <template v-slot:items="{ item }">
        <tr v-if="$vuetify.breakpoint.smAndUp">
          <td>
            <router-link
              class="ok"
              :to="{
                name: current_user.is_admin ? 'tenant-jamKerja.detail' : 'jamKerja.detail',
                params: {
                  tenant_id: tenant_id,
                  organisasi_id: item.organisasi.no_reg,
                  jadwal_id: item.konfigurasi_jadwal_id,
                },
              }"
            >
              {{ pVal(item, 'nama') }}

              <template v-if="+item.k_tipe_jadwal === 1">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="green" v-bind="attrs" v-on="on"> mdi-check-circle </v-icon>
                  </template>
                  <span>Jadwal Berlaku</span>
                </v-tooltip>
              </template>
            </router-link>
          </td>
          <td>{{ item.k_tipe_jadwal === 1 ? 'Reguler' : 'Khusus' }}</td>
          <td>{{ pVal(item, 'tgl_berlaku') | toSDN }}</td>
          <td>{{ pVal(item, 'tgl_berakhir') | toSDN }}</td>
          <td>
            <m-menu left style="float: right" :items="more_menu" :object="item" />
          </td>
        </tr>
        <tr v-else>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[0].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item, 'nama') }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[1].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ item.k_tipe_jadwal == 1 ? 'Reguler' : 'Khusus' }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[2].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item, 'tgl_berlaku') | toSDN }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[3].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item, 'tgl_berakhir') | toSDN }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[4].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              <m-menu left style="float: right" :items="more_menu" :object="item" />
            </div>
          </td>
        </tr>
      </template>
      <template v-slot:footer>
        <v-alert type="info" text>
          <div class="text-caption">
            <b>Keterangan</b> : Penanda centang <b>Hijau</b> menjelaskan
            bahwa itu adalah jam kerja yang digunakan secara reguler/default yang akan diploting oleh sistem pada pola
            kerja di setiap periode. Jam kerja tersebut tidak terbatas waktu tertentu selama masih dijadikan sebagai jam
            kerja reguler/default
          </div>
        </v-alert>
      </template>
    </m-card-list>
    <ChangeDlg ref="dlg" />
    <ChangeDlgJadwal ref="dlgSetJadwal" />
    <ChangeDlgJadwalGrup ref="dlgSetJadwalGrup" />
  </v-container>
</template>

<script>
import { isCan } from '@/tools'
import ChangeDlg from '../components/FormJamKerja.vue'
import ChangeDlgJadwal from '../components/FormSettingJadwal.vue'
import ChangeDlgJadwalGrup from '../components/FormSettingJadwalGrup.vue'
import BlockCard from '@/components/BlockCard'
import { KONVERSI_JAM } from '@/modules/jamKerja/const'

export default {
  components: {
    ChangeDlg,
    ChangeDlgJadwal,
    ChangeDlgJadwalGrup,
    BlockCard,
  },
  data() {
    return {
      items: [],
      textSearch: null,
      page: null,
      cp: 1,
      headers: [
        { text: 'Label Jam Kerja', align: 'left', value: 'nama' },
        { text: 'Tipe Jadwal', align: 'left', value: 'k_tipe_jadwal' },
        { text: 'Mulai Berlaku', align: 'left', value: 'jam_istirahat' },
        { text: 'Akhir Berlaku', align: 'left', value: 'tanggal' },
        { text: '', align: 'left', sortable: false },
      ],
      more_menu: [
        {
          title: 'Detail',
          click: (i, o) => this.onDetail(i, o),
        },
        {
          title: 'Set Default',
          click: (i, o) => this.setDefault(o),
          check: (i, o) => isCan('jadwal.set-default') && +o.k_tipe_jadwal !== 1,
        },
        {
          title: 'Ubah',
          click: (i, o) => this.edit(o),
          check: () => isCan(`jadwal.${this.keyAkses}update`),
        },
        {
          title: 'Hapus',
          click: (i, o) => this.hapus(o),
          check: (i, o) => isCan(`jadwal.${this.keyAkses}destroy`) && o.k_tipe_jadwal == 2,
        },
        {
          title: 'Sinkronisasi',
          click: (i, o) => this.sinkron(o),
          check: () => isCan(`jadwal.tenant-sinkron`),
        },
      ],
      itemZonaWaktu: {
        'Asia/Jakarta': 'WIB',
        'Asia/Makassar': 'WITA',
        'Asia/Jayapura': 'WIT',
      },
    }
  },
  activated() {
    this.load()
  },
  methods: {
    load() {
      this.$store
        .dispatch('jamKerja/get', {
          organisasi_id: this.organisasi_id || this.tenant_id,
          params: {
            page: this.cp,
            keyword: this.textSearch,
          },
        })
        .then((res) => {
          this.page = res.data
          this.items = res.data.data
        })
        .catch((e) => e)
    },
    onDetail(i, o) {
      let params = {
        tenant_id: this.tenant_id,
        jadwal_id: o.konfigurasi_jadwal_id,
      }

      if (!this.current_user.is_admin) {
        this.$set(params, 'organisasi_id', o.organisasi.no_reg)
      }
      this.$router.push({
        name: this.current_user.is_admin ? 'tenant-jamKerja.detail' : 'jamKerja.detail',
        params: params,
      })
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load()
      })
    },
    edit(item) {
      const jamKerja = [...((item && item.detail_jam_kerja) || [])]
      let detail_jam_kerja = []
      jamKerja.forEach((item) => {
        let temp = {}
        Object.keys(item).forEach((key) => {
          if (KONVERSI_JAM.includes(key)) {
            this.$set(temp, key, this.$setTimezone(item[key], 3))
          } else {
            this.$set(temp, key, item[key])
          }
        })
        detail_jam_kerja.push(temp)
      })

      let obj = Object.assign({}, item, { detail_jam_kerja: detail_jam_kerja })
      this.$refs.dlg.open(obj).then(() => {
        this.load()
      })
    },
    setJadwal(o) {
      this.$refs.dlgSetJadwal.openSetJadwal(o).then(() => {
        this.load()
      })
    },
    setJadwalGrup(o) {
      this.$refs.dlgSetJadwalGrup.openSetJadwal(o).then(() => {
        this.load()
      })
    },
    search(textSearch) {
      this.$store
        .dispatch('jamKerja/get', { page: this.cp, search: textSearch })
        .then((res) => {
          this.page = res.data
          this.items = res.data.data
        })
        .catch((e) => e)
    },
    setDefault(item) {
      this.$confirmDanger(
        `Apakah Anda yakin akan memilih jam kerja ini sebagai Jam Kerja Default ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>
      `
      )
        .then(() =>
          this.$store.dispatch('jamKerja/setDefault', {
            kode_tenant: this.tenant_id,
            params: {
              konfigurasi_jadwal_id: item.konfigurasi_jadwal_id,
              kode_organisasi: this.$route.params.organisasi_id,
            },
          })
        )
        .then(() => {
          this.$info('Jam Kerja Berhasil Di Set sebagai Default')
        })
        .then(() => this.load())
        .catch((e) => e)
    },
    hapus(item) {
      this.$confirmDanger(
        `<div class="ma-1 mb-4 pa-1 row red lighten-4 red--text text--darken-4">

            <i class="ma-3 v-icon v-alert__icon mdi mdi-information-outline red--text text--darken-4"></i>

          <div class="col m11 pa-1 pt-3">
            Pastikan Anda benar-benar mengerti apa yang Anda lakukan.
          </div>
        </div>

        Apakah Anda yakin akan menghapus data ini ?<br>
        <div class="mt-2 title grow text-center">
           ${item.nama}<br>
        </div>
      `
      )
        .then(() =>
          this.$store.dispatch('jamKerja/drop', {
            konfigurasi_jadwal_id: item.konfigurasi_jadwal_id,
            organisasi_id: this.organisasi_id || this.tenant_id,
          })
        )
        .then(() => {
          this.$info('Data berhasil dihapus')
        })
        .then(() => this.load())
        .catch((e) => e)
    },
    sinkron(item) {
      this.$confirmDanger(
        `Apakah Anda yakin akan sinkronisasi pengaturan jam kerja berikut ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>
      `
      ).then(() => {
        this.$store
          .dispatch('jamKerja/sinkronisasi', {
            konfigurasi_jadwal_id: item.konfigurasi_jadwal_id,
            kode_tenant: this.tenant_id,
          })
          .then(() => {
            this.$info('Data berhasil disinkronisasi')
          })
          .then(() => this.load())
          .catch((e) => e)
      })
    },
  },
}
</script>
